// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function admin_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
    if (name.TAG === /* Ok */0) {
      var email = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "email"), null));
      if (email.TAG === /* Ok */0) {
        var crt_id = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "crt_id"), null));
        if (crt_id.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    id: id._0,
                    name: name._0,
                    email: email._0,
                    crt_id: crt_id._0
                  }
                };
        }
        var e = crt_id._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".crt_id" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = email._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".email" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".name" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var admin = admin_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "admin"), null));
  if (admin.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              admin: admin._0
            }
          };
  }
  var e = admin._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".admin" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  admin_decode ,
  t_decode ,
  
}
/* No side effect */
